/**
 * Connection Manager $http error interceptor
 *
 * Handles timeouts and other errors.
 *
 * @alias ConnectionManagerInterceptor
 * @type {ngFactory}
 */
function ConnectionManagerInterceptorFactory(TmrConnectionTimeoutError) {
  'ngInject'
  return {
    /**
     * Throws a {@link TmrConnectionTimeoutError} when status is -1 for
     * consistent error handling.
     *
     * @alias ConnectionManagerInterceptor#responseError
     */
    responseError: rejection =>
      Promise.reject(
        rejection.status === -1 ? new TmrConnectionTimeoutError() : rejection
      ),
  }
}

/**
 * Registers the Connection Manager $http error interceptor.
 *
 * @type {ngConfig}
 */
let tmrConnectionManagerConfig = /*@ngInject*/ $httpProvider =>
  $httpProvider.interceptors.push('ConnectionManagerInterceptor')

/**
 * Centralized logic for connection management.
 *
 * Handles timeouts and other errors by leveraging UI Router transition hooks.
 *
 * @type {ngRun}
 * @see https://ui-router.github.io/ng1/docs/latest/classes/transition.transition-1.html
 */
function tmrConnectionManagerRun(
  $transitions,
  $state,
  TmrConnectionTimeoutError
) {
  'ngInject'
  // Handle connection timeouts (error -1).
  $transitions.onError(
    { to: state => state.name != 'app.errorConnectionLost' },
    transition => {
      if (transition.error().detail instanceof TmrConnectionTimeoutError) {
        $state.go('app.errorConnectionLost', {
          prevState: transition.to().name,
        })
      }
    },
    { priority: 1 }
  )
}

export const factory = [
  'ConnectionManagerInterceptor',
  ConnectionManagerInterceptorFactory,
]
export { tmrConnectionManagerConfig as config }
export { tmrConnectionManagerRun as run }
